import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { AppEnum } from 'src/app/appenum';
import { AppService } from 'src/app/services/app.service';
import { CustomTablevalComponent } from '../custom-tableval/custom-tableval.component';
import { CustomTextareaComponent } from '../custom-textarea/custom-textarea.component';
import { PreInspectionReportComponent } from '../pre-inspection-report/pre-inspection-report.component';
import { tempDynamicStoreconfig } from '../tempDynamicStoreconfig';
import { AppSettings } from 'src/app/app.settings';
import { TranslateService } from '@ngx-translate/core';
import { EncryptionService } from 'src/app/services/encryption.service';
import { environment } from 'src/environments/environment';
import { IdbService } from 'src/app/services/idb.service';
import { RecordSelectionComponent } from '../record-selection/record-selection.component';
import { DeleteMediaComponent } from '../delete-media/delete-media.component';
import { LoggingService } from 'src/app/services/logging.service';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
interface ValidationResult {
  stopProcessing: boolean; // whether to stop payload
  canSkipRecommended?: boolean; // allow skipping recommended photos
}
@Component({
  selector: 'app-custom-dynamic-form-builder',
  templateUrl: './custom-dynamic-form-builder.component.html',
  styleUrls: ['./custom-dynamic-form-builder.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class CustomDynamicFormBuilderComponent implements OnInit {
  public formFieldsJson: any = [];
  isTooltipVisible = false;
  @Input() customFormJson: any;
  @Output() _customFormValues = new EventEmitter();
  @Output() formChanged = new EventEmitter<void>();
  @Output() templateQuesUpdated = new EventEmitter<any[]>();
  @Input() hiddenSubmitButton = false;
  @Input() submitEvent: any;
  @Input() PageName: string;
  @Input() taskDetails: any;
  public zoneKeys: any = [];
  public _customForm: UntypedFormGroup = new UntypedFormGroup({});

  public valueChangeSub;

  public datalist = [];
  public dataFromAPI;
  public lat;
  public long;
  public fileList;
  public fileobj: any;
  public previewFile = false;
  public downloadFile = false;
  public componentName = 'custom-dynamic-form-builder';
  lastKey: any;
  tableRowvalue: any;
  deleteRowMsg: any;
  confirmText: any;
  cancelText: any;
  yesText: any;
  description: null;
  selectedDependents: { [key: string]: any } = {};

  public tempData = [{
    "id": "temp_ques1",
    "label": {
      "en": "Do You Want Hide Roof Control?",
    },
    "isRequired": false,
    "controlName": "temp_ques1",
    "controlType": "select",
    "layoutClass": "col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
    "placeholder": "",
    "controlvalue": "",
    "controlwidth": "50",
    "inputPattern": "",
    "controlParent": "temp_general_head1",
    "dependentControlVisibility": {
      'controlName': 'RoofLine'
    },
    "dependentControlDetail": {
      "isDependent": false,
      "controlName": "",
      "dependentValue": "",
      "condition": ""
    },
    "controlOptions": [
      {
        "id": "1",
        "option": {
          "en": "Yes",
        }
      },
      {
        "id": "2",
        "option": {
          "en": "No",
        }
      }
    ],
    "controlvalueKey": ""
  }]

  mediaDetails: any;
  constructor(private _formBuilder: UntypedFormBuilder,
    public _appenum: AppEnum,
    public _tempDynamicStoreconfig: tempDynamicStoreconfig,
    public _alertController: AlertController,
    public modalCtrl: ModalController,
    public _translateService: TranslateService,
    public _appServices: AppService, public _appSetting: AppSettings,
    public encryptionService: EncryptionService,
    private loggingService: LoggingService,
    public _localDbService: IdbService) {
    wrapAllMethodsWithLogging(this, this.componentName);
    this.deleteRowMsg = this._translateService.instant('common_text.delete_row_text');
    this.confirmText = this._translateService.instant('common_alert_text.confirm_title_text')
    this.cancelText = this._translateService.instant('common_btn_text.cancel_btn');
    this.yesText = this._translateService.instant('common_btn_text.yes_btn');
  }

  async ngOnInit() {
    this.formFieldsJson = [];

    this._customForm = this._formBuilder.group({});
    console.log("this.customFormJson", this.customFormJson)
    this.zoneKeys = Object.keys(this.customFormJson);
    console.log("this.zoneKeys", this.zoneKeys)
    this.zoneKeys.forEach((key: any, i) => {
      if (this.customFormJson[i].templateQues && this.customFormJson[i].templateQues.length > 0) {
        this.formFieldsJson = [].concat.apply(this.formFieldsJson, (this.customFormJson[i].templateQues));
      }
    });

    for (var i = new Date().getFullYear(); i >= 1900; i--) {
      this.datalist.push({ id: i, option: i });
    }
    this.getDataAndAddForm();
    this._formRender();
    this._appServices.isLanguageChanged.subscribe(res => {
      if (res) {
        this._formAddValue();
      }
    })
  }
  isVisible(formData: any): boolean {
    return !formData.visibleOn || formData.visibleOn.includes(this._appServices.appType);
  }

  async getDataAndAddForm() {
    if (this.taskDetails.TaskId) {
      const FnolData = await this._localDbService.getTaskDetail(this.taskDetails.TaskId);
      if (FnolData?.taskId === this.taskDetails.TaskId && FnolData?.data) {
        this.dataFromAPI = FnolData?.data;
        setTimeout(() => {
          this._formAddValue();
        }, 1000)
      } else {
        this.getCustomerDataByDocID(this.taskDetails.TaskId);
      }
    }
  }

  // _formAddValue() {
  //   this.formFieldsJson.forEach((field: any) => {
  //     if (field.hasOwnProperty('controlvalueKey')) {
  //       if (this.dataFromAPI.hasOwnProperty(field['controlvalueKey'])) {
  //         this._customForm.controls[field['controlName']].setValue(typeof (this.dataFromAPI[field['controlvalueKey']]) == 'object' ? this.dataFromAPI[field['controlvalueKey']][this._appSetting.selectedLanguage] : this.dataFromAPI[field['controlvalueKey']]);
  //       }
  //     }
  //   });
  //   console.log("this.formFieldsJson", this.formFieldsJson)

  //   let matchedFunctions: any[] = [];
  //   const controlNames = this.formFieldsJson.map((d: any) => d.controlName);
  //   for (const template of this._tempDynamicStoreconfig.externalApiTemplateData) {
  //     for (const func of template.function_data) {
  //       const found = func.apidata.find(a => controlNames.includes(a.controlId));
  //       if (found) {
  //         matchedFunctions.push(func);
  //       }
  //     }
  //   }
  //   console.log("Matched functions:", matchedFunctions);
  //   for (const matchedFunction of matchedFunctions) {
  //     const allFilled = matchedFunction.apidata.every(field => {
  //       const val = this._customForm.controls[field.controlId]?.value;
  //       return val !== undefined && val !== null && val !== '';
  //     });

  //     console.log("allFilled", matchedFunction.function_name, allFilled);

  //     if (allFilled) {
  //       this.fetchExternalData(matchedFunction);
  //     } else {
  //       console.log(
  //         "Skipping API call, not all controls are filled for:",
  //         matchedFunction.function_name
  //       );
  //     }
  //   }
  // }

  _formAddValue() {
    // this.formFieldsJson.forEach((field: any) => {
    //   if (field.hasOwnProperty('controlvalueKey')) {
    //     if (this.dataFromAPI.hasOwnProperty(field['controlvalueKey'])) {
    //       this._customForm.controls[field['controlName']].setValue(
    //         typeof this.dataFromAPI[field['controlvalueKey']] === 'object'
    //           ? this.dataFromAPI[field['controlvalueKey']][this._appSetting.selectedLanguage]
    //           : this.dataFromAPI[field['controlvalueKey']]
    //       );
    //     }
    //   }
    // });
    this.formFieldsJson.forEach((field: any) => {
      if (field.controlType !== 'text' && field.controlType !== 'textarea') {
        return;
      }
      const control = this._customForm.controls[field.controlName];
      if (!control) return;
      const hasKey = field.controlvalueKey && field.controlvalueKey.trim() !== '';
      const hasValue = field?.controlvalue && field?.controlvalue.trim() !== '';
      // if controlvalueKey & controlvalue are both non-empty → use JSON value
      if (hasKey && hasValue) {
        control.setValue(field?.controlvalue);
      }
      else if (hasKey) {
        const key = field.controlvalueKey;
        if (this.dataFromAPI && this.dataFromAPI.hasOwnProperty(key)) {
          let value = this.dataFromAPI[key];
          // Handle object values (like { en: 'Home Insurance' })
          if (typeof value === 'object' && value !== null) {
            value = value[this._appSetting.selectedLanguage] || '';
          }
          control.setValue(value);
          field.controlvalue = value; // also update JSON
        }
      }
    });

    let matchedFunctions: any[] = [];
    const controlNames = this.formFieldsJson.map((d: any) => d.controlName);

    // find all matched functions
    for (const template of this._tempDynamicStoreconfig.externalApiTemplateData) {
      for (const func of template.function_data) {
        const found = func.apidata.find(a => controlNames.includes(a.controlId));
        if (found) {
          matchedFunctions.push(func);
        }
      }
    }
    console.log("matchedFunctions", matchedFunctions)
    for (const matchedFunction of matchedFunctions) {
      const allFilled = matchedFunction.apidata.every(field => {
        if (field.mandatory === 0) return true;
        console.log("this._customForm.controls[field.controlId]?.value;", this._customForm.controls[field.controlId]?.value)
        const val = this._customForm.controls[field.controlId]?.value;
        return val !== undefined && val !== null && val !== '';
      });
      console.log("allFilled", allFilled)
      if (allFilled) {
        if (matchedFunction.execution_mode === 'auto') {
          //auto mode → call API immediately
          const triggerControl = this.formFieldsJson.find(f => f.controlName === matchedFunction.trigger_control_id);
          console.log("triggerControl", triggerControl)
          triggerControl.status != 'success' ? this.fetchExternalData(matchedFunction, this.customFormJson[0].templateId) : null
        } else if (matchedFunction.execution_mode === 'on_request') {
          //Attach linkedFunction directly to your trigger control
          const triggerControl = this.formFieldsJson.find(f => f.controlName === matchedFunction.trigger_control_id);
          if (triggerControl) {
            // triggerControl.status = 'default';
            triggerControl.linkedFunction = matchedFunction; // keep reference
          }
        }

      } else {
        if (matchedFunction.execution_mode === 'auto') {
          // auto mode → call API immediately
          const triggerControl = this.formFieldsJson.find(f => f.controlName === matchedFunction.trigger_control_id);
          if (triggerControl) {
            triggerControl.label = {
              "en": "Please fill required value and retry",
              "id": "Please fill required value and retry",
              "sp": "Please fill required value and retry"
            }
            triggerControl.status = 'error'
            triggerControl.linkedFunction = matchedFunction;
          }

        } else if (matchedFunction.execution_mode === 'on_request') {
          // Attach linkedFunction directly to your trigger control
          const triggerControl = this.formFieldsJson.find(f => f.controlName === matchedFunction.trigger_control_id);

          if (triggerControl) {
            triggerControl.linkedFunction = matchedFunction;
          }
        }
      }
    }
  }


  async onGoClick(formData: any, templateId: any) {
    if (formData.linkedFunction) {
      formData.apiError = false;
      formData.status = 'loading';
      formData.label = {
        "en": "Fetching data",
        "id": "Fetching data",
        "sp": "Fetching data"
      }
      const success = await this.fetchExternalData(formData.linkedFunction, templateId);
      if (success) {
        // Double-check all values got filled
        const allFilled = formData.linkedFunction.apidata.every(field => {
          const val = this._customForm.controls[field.controlId]?.value;
          return val !== undefined && val !== null && val !== '';
        });
        if (allFilled) {
          formData.showGoButton = false;
          formData.apiError = false; // hide only after proper filling
          formData.status = 'success';
          formData.label = {
            "en": "Data fetched successfully",
            "id": "Data fetched successfully",
            "sp": "Data fetched successfully"
          }
        }
      } else {
        formData.showGoButton = false;
        formData.apiError = true; // ❌ show Retry
        formData.status = 'error';
        formData.label = {
          "en": "Error while fetching data please retry",
          "id": "Error while fetching data please retry",
          "sp": "Error while fetching data please retry"
        }
      }
    }
  }



  getCustomerDataByDocID(TaskId: string) {
    const postJson = {
      // documentId : documentID,
      taskId: TaskId
    };
    var taskDetail = {
      TaskId: this.taskDetails.TaskId,
      status: 'inprogress'
    }
    // getFNOLData
    this._appServices.postDataWithPromise(environment.endpoint.getFNOLDataTemplate, postJson).then(async (res: any) => {
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: environment.endpoint.getFNOLDataTemplate,
          payLoad: postJson,
          response: {
            responseCode: res.StatusCode,
            responseMsg: res.Message,
            result: res
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(
        res.StatusCode != 200
          ? this._appenum.EntityOfLogLevel.Critical
          : this._appenum.EntityOfLogLevel.Info,
        `${res.StatusCode != 200 ? 'FRONTEND_ALERT ' : ''} getFNOLDataTemplate Api Call to get FnolData Detail`,
        this.componentName,
        paramRequest.httpRequest,
        paramRequest.taskDetails,
        environment.endpoint.getFNOLDataTemplate   // apiName — one of your 5 Critical APIs
      );
      if (res.StatusCode == '200') {
        await this._localDbService.saveFnolTemplateData(TaskId, res.Data[0]);
        const FnolData = await this._localDbService.getTaskDetail(TaskId);
        this.dataFromAPI = FnolData.data
      } else {
        this._appServices.presentToast(res.Message[this._appSetting.selectedLanguage] != undefined ? res.Message[this._appSetting.selectedLanguage] : res.Message[this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected))]);
      }
      this._formAddValue();
    }, (err) => {
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: environment.endpoint.getFNOLDataTemplate,
          payLoad: postJson,
          response: {
            responseCode: err.status,
            responseMsg: err.message,
            result: err
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Critical, 'FRONTEND_ALERT getFNOLDataTemplate Api Call to get FnolData Detail', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.getFNOLDataTemplate);
      this._formAddValue();
    });
  }

  _formRender() {
    const _dynamicFormControls: any = {};
    this.formFieldsJson.forEach((field: any) => {
      var validation = [];
      if (field['isRequired']) {
        validation.push(Validators.required);
      }
      if (field['inputPattern'] && field['inputPattern'] != '') {
        validation.push(Validators.pattern(field['inputPattern']))
      }
      if (field['controlType'] != 'checkbox') {
        _dynamicFormControls[field['controlName']] = new UntypedFormControl(field['controlvalue'] || '', validation);
      } else {
        const formArray: UntypedFormArray = new UntypedFormArray([]);
        for (var i = 0; i < field['controlvalue'].length; i++) {
          formArray.push(new UntypedFormControl((field['controlvalue'][i]).trim()));
        }
        _dynamicFormControls[field['controlName']] = formArray
      }
    });
    this._customForm = new UntypedFormGroup(_dynamicFormControls);

    setTimeout(() => {
      this._customForm.valueChanges.subscribe(res => {
        this._customFormSummarySubmit();
      });
    }, 100);
  }

  public ngOnDestroy() {
    if (this.valueChangeSub) {
      this.valueChangeSub.unsubscribe();
    }
  }



  async goToCustomTextArea(formData: any, i: number, templateName: string, templateId: any) {
    var controlName = formData.controlName;
    var obj = {
      component: CustomTextareaComponent,
      cssClass: 'my-custom-class1',
      componentProps: { value: formData.controlvalue, label: formData.label[this._appSetting.selectedLanguage] }
    }
    let modal = await this.modalCtrl.create(obj);

    modal.present();
    const { data } = await modal.onWillDismiss();
    if (data?.data != undefined) {
      this._customForm.controls[controlName].patchValue(data.data);
      const isControlValue: any = await this._localDbService.getChecklistFromLocalDbByControlName(
        this.taskDetails.TaskId, controlName, templateId
      );
      if (isControlValue.status && isControlValue.data.length > 0) {
        await this.updateChecklistTableValue(formData, templateName, templateId);
      } else {
        await this.insertcontrolvalue(formData, templateName, templateId);
      }
    }

    this.customFormJson[i].templateQues.forEach((res: any) => {
      if (formData.controlName == res.dependentControlDetail.controlName) {
        if (formData.controlvalue == res.dependentControlDetail.dependentValue) {
          res.dependentControlDetail.isDependent = false;
        } else {
          this._customForm.controls[res.controlName].patchValue("");
          res.controlvalue = "";
          res.dependentControlDetail.isDependent = true;
        }
      }
    });

    if (this.PageName != "dynamicCard") {
      this._customFormValues.emit(this.customFormJson);
    }
  }


  _customFormSummarySubmit() {
    if (this.formFieldsJson?.length > 0) {
      this.zoneKeys.forEach((key: any, i) => {
        if (this.customFormJson[i].templateQues.length > 0) {
          this.customFormJson[i].templateQues.map((item: any) => {
            item.controlvalue = this._customForm.value[item.controlName];
          });
        }
      });
      this._tempDynamicStoreconfig.serverDataQues = this.customFormJson;
      if (!this._customForm.valid) {
        Object.keys(this._customForm.controls).forEach(field => {
          const control: any = this._customForm.get(field);
          control.markAsTouched({ onlySelf: true });
        });
        return;
      }
    }

  }

  _customFormSubmit() {
    if (this.formFieldsJson?.length > 0) {
      this.zoneKeys.forEach((key: any) => {
        if (this.customFormJson[key].templateQues.length > 0) {
          this.customFormJson[key].templateQues.map((item: any) => {
            if (item.controlType != 'table') {
              item.controlvalue = this._customForm.value[item.controlName]
            }
          });
        }
      });
    }
    this._customFormValues.emit(this.customFormJson);
    localStorage.setItem(
      'lastSelectSegment',
      'Media'
    );
    this.formChanged.emit();
  }

  async filterVal(data, i, templateName, templateId) {
    //Check if previously selected option has media before switching
    const previousOption = data.controlOptions.find((opt: any) => opt.isChecked);
    const newValue = data.controlvalue;
    console.log("previousOption", previousOption)
    if (previousOption && previousOption.id != newValue) {
      const hasMedia = this.checkDependentMediaExists(previousOption, templateId);

      if (hasMedia) {
        const confirmed = await this.showDeleteMediaFirstPopup(previousOption.option[this._appSetting.selectedLanguage], this.mediaDetails, templateId);
        if (confirmed) {
          data.controlvalue = newValue;
          this._customForm.controls[data.controlName]?.patchValue(newValue);
          this.clearMediaFromTempJson(previousOption);
        } else {
          data.controlvalue = previousOption.id;
          this._customForm.controls[data.controlName]?.patchValue(previousOption.id);
          return;
        }
      }
    }

    // Save/update the selected value in local DB
    const isControlValue: any = await this._localDbService.getChecklistFromLocalDbByControlName(
      this.taskDetails.TaskId,
      data.controlName,
      templateId
    );
    if (isControlValue.status && isControlValue.data.length > 0) {
      await this.updateChecklistTableValue(data, templateName, templateId);
    } else {
      await this.insertcontrolvalue(data, templateName, templateId);
    }

    const dependentToRemove = this.customFormJson[i].templateQues.filter(
      q => q.parentControlName === data.controlName
    );
    if (dependentToRemove.length > 0) {
      for (const dep of dependentToRemove) {
        await this._localDbService.deleteChecklistFromLocalDbByControlName(
          this.taskDetails.TaskId,
          dep.controlName,
          templateId
        );
        this._customForm.removeControl(dep.controlName);
      }
    }

    // Remove from UI
    this.customFormJson[i].templateQues = this.customFormJson[i].templateQues.filter(
      q => q.parentControlName !== data.controlName
    );

    // Step 3: Find selected option
    const selectedOption = data.controlOptions.find(opt => opt.id == data.controlvalue);
    if (selectedOption && selectedOption.dependentControls?.length) {
      // const dependentClones = selectedOption.dependentControls.map(dc => ({
      //   ...dc,
      //   parentControlName: data.controlName
      // }));
      const dependentClones = selectedOption.dependentControls.map((dc: any) => ({
        id: dc.id,
        label: dc.label,
        isRequired: dc.isRequired,
        controlName: dc.controlName,
        controlType: dc.controlType,
        layoutClass: dc.layoutClass,
        placeholder: dc.placeholder,
        controlvalue: dc.controlvalue,
        controlwidth: dc.controlwidth,
        inputPattern: dc.inputPattern,
        controlParent: dc.controlParent,
        dependentControlDetail: dc.dependentControlDetail,
        controlOptions: dc.controlOptions,
        controlvalueKey: dc.controlvalueKey,
        parentControlName: data.controlName
      }));

      const parentIndex = this.customFormJson[i].templateQues.findIndex(
        q => q.controlName === data.controlName
      );
      this.customFormJson[i].templateQues.splice(parentIndex + 1, 0, ...dependentClones);

      dependentClones.forEach(dc => {
        this._customForm.addControl(dc.controlName, this._formBuilder.control(''));
      });
    }

    // Step 7: Reset dependent control values
    this.customFormJson[i].templateQues.forEach(res => {
      if (data.controlName === res.dependentControlDetail?.controlName) {
        res.dependentControlDetail.dependentValue = data.controlvalue;
        this._customForm.controls[res.controlName]?.patchValue("");
        res.controlvalue = "";
      }
    });

    data.controlOptions.forEach((opt: any) => {
      opt.isChecked = (data.controlvalue == opt.id);
    });
    await this.saveTemplateQuesChangesToIdb(templateId);
    await this.hideShowSelectControls(data, templateId);
    this.formChanged.emit();
    this.templateQuesUpdated.emit(this.customFormJson);
  }

  collectVisibilityMap(
    options: any[],
    visibilityMap: Map<string, boolean>,
    parentChecked: boolean
  ) {
    // First, check if any option in this group is selected
    const selectedOption = options.find(opt => !!opt.isChecked);

    options.forEach(opt => {
      const isChecked = !!opt.isChecked && parentChecked; // only true if parent is also checked

      // 1. For each dependentControlVisibility → mark visible only if this option is the selected one
      opt?.dependentControlVisibility?.forEach((dep: any) => {
        visibilityMap.set(dep.controlName, isChecked && selectedOption === opt);
      });

      // 2. If this option has dependentControls → recurse
      if (opt.dependentControls?.length) {
        this.collectVisibilityMap(opt.dependentControls, visibilityMap, isChecked && selectedOption === opt);
      }

      // 3. If option has controlOptions → recurse into them
      if (opt.controlOptions?.length) {
        this.collectVisibilityMap(opt.controlOptions, visibilityMap, isChecked && selectedOption === opt);
      }
    });
  }


  async hideShowSelectControls(formData: any, templateId: any) {
    const templateDetails = await this._localDbService.getDynamicCardTaskTemplateFromIdb(
      this.taskDetails.TaskId)
    const visibilityMap = new Map<string, boolean>();
    this.collectVisibilityMap(formData.controlOptions, visibilityMap, true);
    const updateVisibility = (items: any[]) =>
      items.map(item => {
        if (visibilityMap.get(item.controlName) && visibilityMap.has(item.controlName)) {
          return {
            ...item,
            isVisible: true
          };
        } else if (!visibilityMap.get(item.controlName) && visibilityMap.has(item.controlName)) {
          return {
            ...item,
            isVisible: false
          };
        } else {
          return item
        }

      });

    // 3. Update everywhere
    this._tempDynamicStoreconfig.tempCustomJson = updateVisibility(
      this._tempDynamicStoreconfig.tempCustomJson
    );

    // templateDetails[0].templateJson = updateVisibility(
    //   templateDetails[0].templateJson
    // );

    templateDetails.forEach((template: any, idx: number) => {
      templateDetails[idx].templateJson = updateVisibility(template.templateJson);
    });
    this._tempDynamicStoreconfig.serverData = this._tempDynamicStoreconfig.serverData.map(element => ({
      ...element,
      templateJson: updateVisibility(element.templateJson),
      // templateQues: element.templateId == this.customFormJson[0].templateId ? this.customFormJson[0]?.templateQues : []
    }));

    for (const template of templateDetails) {
      await this._localDbService.updateTemplateAfterControlAdd(
        this.taskDetails.TaskId,
        template.templateId,
        template.templateJson
      );
    }
  }

  async conditionChange(data, i, templateName, templateId) {
    const previousOption = data?.controlOptions?.find((opt: any) => opt.isChecked);
    const newValue = data.controlvalue;

    if (previousOption && previousOption.id != newValue) {
      const hasMedia = this.checkDependentMediaExists(previousOption, templateId);

      if (hasMedia) {
        const confirmed = await this.showDeleteMediaFirstPopup(previousOption.option[this._appSetting.selectedLanguage], this.mediaDetails, templateId);

        if (confirmed) {
          data.controlvalue = newValue;
          this._customForm.controls[data.controlName]?.patchValue(newValue);
          this.clearMediaFromTempJson(previousOption);

        } else {
          data.controlvalue = previousOption.id;
          this._customForm.controls[data.controlName]?.patchValue(previousOption.id);
          return;
        }
      }
    }

    const isControlValue: any = await this._localDbService.getChecklistFromLocalDbByControlName(
      this.taskDetails.TaskId, data.controlName, templateId
    );
    if (isControlValue.status && isControlValue.data.length > 0) {
      await this.updateChecklistTableValue(data, templateName, templateId);
    } else {
      await this.insertcontrolvalue(data, templateName, templateId);
    }

    this.customFormJson[i].templateQues.forEach(res => {
      if (data.controlName == res.dependentControlDetail.controlName &&
        data.controlvalue == res.dependentControlDetail.dependentValue) {
        res.dependentControlDetail.isDependent = false;
      } else if (data.controlName == res.dependentControlDetail.controlName &&
        data.controlvalue != res.dependentControlDetail.dependentValue) {
        this._customForm.controls[res.controlName].patchValue("");
        res.controlvalue = "";
        res.dependentControlDetail.isDependent = true;
      }
    });

    this.customFormJson[i].templateQues.forEach(item => {
      item.controlvalue = this._customForm.value[item.controlName];
    });

    // Nested Controls
    if (data?.controlOptions && data?.controlOptions.length > 0) {
      const dependentToRemove = this.customFormJson[i].templateQues.filter(
        (q: any) => q.parentControlName === data.controlName
      );
      if (dependentToRemove.length > 0) {
        for (const dep of dependentToRemove) {
          await this._localDbService.deleteChecklistFromLocalDbByControlName(
            this.taskDetails.TaskId,
            dep.controlName,
            templateId
          );
          this._customForm.removeControl(dep.controlName);
        }
        this.customFormJson[i].templateQues = this.customFormJson[i].templateQues.filter(
          (q: any) => q.parentControlName !== data.controlName
        );
      }
      const selectedOption = data?.controlOptions?.find(opt => opt.id == data.controlvalue);
      if (selectedOption && selectedOption.dependentControls?.length) {
        const dependentClones = selectedOption.dependentControls.map((dc: any) => ({
          id: dc.id,
          label: dc.label,
          isRequired: dc.isRequired,
          controlName: dc.controlName,
          controlType: dc.controlType,
          layoutClass: dc.layoutClass,
          placeholder: dc.placeholder,
          controlvalue: dc.controlvalue,
          controlwidth: dc.controlwidth,
          inputPattern: dc.inputPattern,
          controlParent: dc.controlParent,
          dependentControlDetail: dc.dependentControlDetail,
          controlOptions: dc.controlOptions,
          controlvalueKey: dc.controlvalueKey,
          parentControlName: data.controlName
        }));

        const parentIndex = this.customFormJson[i].templateQues.findIndex(
          q => q.controlName === data.controlName
        );
        this.customFormJson[i].templateQues.splice(parentIndex + 1, 0, ...dependentClones);

        dependentClones.forEach(dc => {
          this._customForm.addControl(dc.controlName, this._formBuilder.control(''));
        });
      }

      data.controlOptions.forEach((opt: any) => {
        opt.isChecked = (data.controlvalue == opt.id);
      });
      await this.saveTemplateQuesChangesToIdb(templateId);
      await this.hideShowSelectControls(data, templateId);
    }

    if (this.PageName != "dynamicCard") {
      this._customFormValues.emit(this.customFormJson);
    }
    this.formChanged.emit();
    this.templateQuesUpdated.emit(this.customFormJson);
  }

  async onInputChange(data, i, templateName, templateId) {
    // ... your existing logic ...
    const isControlValue: any = await this._localDbService.getChecklistFromLocalDbByControlName(
      this.taskDetails.TaskId, data.controlName, templateId
    );
    if (isControlValue.status && isControlValue.data.length > 0) {
      console.log("update")
      await this.updateChecklistTableValue(data, templateName, templateId);
    } else {
      console.log("insert")
      await this.insertcontrolvalue(data, templateName, templateId);
    }
    // this.customFormJson[i].templateQues.forEach((res: any) => {
    //   if (data.controlName == res.dependentControlDetail.controlName) {
    //     if (data.controlvalue == res.dependentControlDetail.dependentValue) {
    //       res.dependentControlDetail.isDependent = false;
    //     } else {
    //       this._customForm.controls[res.controlName].patchValue("");
    //       res.controlvalue = "";
    //       res.dependentControlDetail.isDependent = true;
    //     }
    //   }
    // });
    console.log("this.customFormJson", this.customFormJson)
    this.formChanged.emit(); // ← add at end
  }
  private async delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private async callExternalApiWithRetry(postJson: any, logRequest: any, maxRetries = 3): Promise<any> {
    let lastRes: any;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const res: any = await this._appServices.postDataWithPromise(environment.endpoint.fetchExternalApiData, postJson);
        console.log("extrenal response", res)
        this.loggingService.handleResponseLog(
          res.StatusCode == 200 ? 'info' : 'critical',
          logRequest,
          res.StatusCode,
          res.Message,
          `${res.StatusCode != 200 ? 'FRONTEND_ALERT | ' : ''}fetchExternalApiData Api Call (Attempt ${attempt}/${maxRetries})`,
          this.componentName,
          environment.endpoint.fetchExternalApiData
        );

        if (res.StatusCode == 200 || res.StatusCode == 404) {
          return res;
        }

        lastRes = res; // keep the latest non-200 || 404 response in case all retries fail

        if (attempt < maxRetries) {
          await this.delay(1000 * attempt); // simple backoff: 1s, 2s, ...
        }
      } catch (err) {
        this.loggingService.logApiError(
          'critical',
          logRequest,
          err,
          `FRONTEND_ALERT fetchExternalApiData Api Call (Attempt ${attempt}/${maxRetries})`,
          this.componentName,
          environment.endpoint.fetchExternalApiData,
        );

        if (attempt === maxRetries) {
          throw err; // exhausted retries, propagate error
        }
        await this.delay(1000 * attempt);
      }
    }

    return lastRes;
  }

  async fetchExternalData(responseData: any, templateId: any): Promise<boolean> {
    const externalApiInput: any = {};
    const allFieldsFilled = responseData.apidata.every(field => {
      const formValue = this._customForm.controls[field.controlId]?.value;

      if (field.mandatory === 0) {
        if (formValue !== undefined && formValue !== '' && formValue !== null) {
          externalApiInput[field.apiInputKey] = formValue;
        }
        return true;
      }

      if (formValue !== undefined && formValue !== '' && formValue !== null) {
        externalApiInput[field.apiInputKey] = formValue;
        return true;
      } else {
        var message = this._translateService.instant('commonthird_party_text fill_required_fields_text');
        this._appServices.presentToast(message, 'custom-toast-error');
        return false;
      }
    });

    if (!allFieldsFilled) {
      return Promise.resolve(false);
    }

    const postJson = {
      orgId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId)),
      functionName: responseData.function_name,
      taskId: this.taskDetails.TaskId,
      externalApiInput
    };

    const logRequest: any = {
      apiEndUrl: 'fetchExternalApiData',
      reqBody: postJson,
    };

    try {
      const res: any = await this.callExternalApiWithRetry(postJson, logRequest, 3);
      const { StatusCode, Message, Data } = res;
      // this._appServices.loaderDismiss();
      if (StatusCode == 200) {
        const template_Data = Data[0].templateData;
        const filled = await this.fillThirdPatryData(template_Data, templateId);

        if (filled) {
          const triggerControl = this.formFieldsJson.find(
            f => f.controlName === responseData.trigger_control_id
          );
          if (triggerControl) {
            triggerControl.status = 'success';
          }
        }
        return filled;
      } else if (StatusCode == 500) {
        return false;
      } else if (StatusCode == 503) {
        return false;
      } else if (StatusCode == 404) {
        const warnMessage = this._appServices.getLocalizedMessage(Message);
        const template_Data = [
          {
            "apidata": [
              { "controlId": "base_ques16", "apiResponseKeyValue": "No Data Found" },
              { "controlId": "base_ques17", "apiResponseKeyValue": 'No Data Found' },
              { "controlId": "base_ques18", "apiResponseKeyValue": 'No Data Found' },
              { "controlId": "base_ques19", "apiResponseKeyValue": 'No Data Found' },
              { "controlId": "base_ques20", "apiResponseKeyValue": 'No Data Found' },
              { "controlId": "base_ques21", "apiResponseKeyValue": 'No Data Found' },
              { "controlId": "base_ques22", "apiResponseKeyValue": 'No Data Found' },
              { "controlId": "base_ques23", "apiResponseKeyValue": "No Data Found" }
            ]
          }
        ];
        const filled = await this.fillThirdPatryData(template_Data, templateId);
        if (filled) {
          const triggerControl = this.formFieldsJson.find(
            f => f.controlName === responseData.trigger_control_id
          );
          if (triggerControl) {
            triggerControl.status = 'success';
          }
        }
        return false;
      } else {
        return false;
      }
    } catch (err) {
      this.loggingService.logApiError(
        'critical',
        logRequest,
        err,
        `FRONTEND_ALERT fetchExternalApiData Api Call Catch Block`,
        this.componentName,
        environment.endpoint.fetchExternalApiData
      );
      // this._appServices.loaderDismiss();
      return false;
    }
  }

  async fillThirdPatryData(template_Data: any, templateId): Promise<boolean> {
    const apidata = template_Data[0].apidata;
    let filled = false;
    for (const item of apidata) {
      const value = item.apiResponseKeyValue;

      if (Array.isArray(value) && value.length > 0) {
        // 📌 apiResponseKeyValue is an array of records
        if (value.length === 1) {
          // only 1 record → auto fill
          this.applyRecord(value[0], templateId);
          filled = true;
        } else {

          //multiple records → show popup for selection
          const formFieldMap = new Map(
            this.formFieldsJson.map(field => [field.controlName, field.label])
          );

          // Loop through each record in the API response
          // const enrichedRecords = value.map(record =>
          //   record.map(item => ({
          //     ...item,
          //     label: formFieldMap.get(item.controlId) || null // attach label if found
          //   }))
          // );

          // Loop through each record in the API response
          const enrichedRecords = value.map(record =>
            record.map(item => {
              // If value is array (nested groups like ctrl_buyers_parent)
              if (Array.isArray(item.apiResponseKeyValue)) {
                return {
                  ...item,
                  label: formFieldMap.get(item.controlId) || null,
                  apiResponseKeyValue: item.apiResponseKeyValue.map(group =>
                    group.map(child => ({
                      ...child,
                      label: formFieldMap.get(child.controlId) || null
                    }))
                  )
                };
              }

              // Normal field
              return {
                ...item,
                label: formFieldMap.get(item.controlId) || null
              };
            })
          );
          const selectedRecord = await this.showRecordSelectionPopup(enrichedRecords);
          if (selectedRecord) {
            this.applyRecord(selectedRecord, templateId);
            filled = true
          } else {
            return false; // user closed without selecting
          }
        }
      } else if (value !== null && value !== undefined) {
        // 📌 direct value (string, date, number, etc.)
        this._customForm.controls[item.controlId]?.setValue(value);

        const formField = this.formFieldsJson.find(f => f.controlName === item.controlId);
        if (formField && 'isEnable' in formField) {
          formField.isEnable = true;
        }
        // this.updateChecklist(formField, templateId);
        const isControlValue: any = await this._localDbService.getChecklistFromLocalDbByControlName(this.taskDetails.TaskId, formField.controlName, templateId);
        if (isControlValue.status && isControlValue.data.length > 0) {
          await this.updateChecklist(formField, templateId);
        } else {
          await this.insertChecklistPrefill(formField, templateId);
        }
        filled = true;
      }
    }

    return filled;// nothing filled
  }

  private async applyRecord(record: any, templateId: string) {
    const apiMap = new Map<string, any>();

    // Build a map of controlId → apiResponseKeyValue (flatten nested children also)
    (record || []).forEach((r: any) => {
      if (Array.isArray(r.apiResponseKeyValue)) {
        // Handle nested groups inside array
        const groups = Array.isArray(r.apiResponseKeyValue[0])
          ? r.apiResponseKeyValue
          : [r.apiResponseKeyValue];

        groups.forEach((group: any[]) => {
          group.forEach((child: any) => {
            apiMap.set(child.controlId, child.apiResponseKeyValue);
          });
        });
      }

      // Always map parent controlId too
      apiMap.set(r.controlId, r.apiResponseKeyValue);
    });


    //  Loop through form fields and apply values
    for (const field of this.formFieldsJson) {
      if (!field?.controlName) continue;

      const apiValue = apiMap.get(field.controlName);
      if (apiValue !== undefined) {
        let finalValue: any;

        if (Array.isArray(apiValue)) {
          // Distinguish between single group vs multiple groups
          if (Array.isArray(apiValue[0])) {
            // Multiple groups → preserve structure
            finalValue = apiValue.map((group: any[]) =>
              group.map((child: any) => ({
                controlId: child.controlId,
                value: child.apiResponseKeyValue,
                label:
                  this.formFieldsJson.find(f => f.controlName === child.controlId)?.label || null
              }))
            );
          } else {
            // Single group → wrap in array
            finalValue = [
              apiValue.map((child: any) => ({
                controlId: child.controlId,
                value: child.apiResponseKeyValue,
                label:
                  this.formFieldsJson.find(f => f.controlName === child.controlId)?.label || null
              }))
            ];
          }
        } else {
          finalValue = apiValue;
        }
        this._customForm.controls[field.controlName]?.setValue(finalValue);

        // Enable the field if required
        if ("isEnable" in field) {
          field.isEnable = true;
        }

        // Sync with local DB
        const isControlValue: any =
          await this._localDbService.getChecklistFromLocalDbByControlName(
            this.taskDetails.TaskId,
            field.controlName,
            templateId
          );
        if (isControlValue.status && isControlValue.data.length > 0) {
          await this.updateChecklist(field, templateId);
        } else {
          await this.insertChecklistPrefill(field, templateId);
        }
      }
    }
  }







  /**
   * Show popup for user to choose one record
   */
  private async showRecordSelectionPopup(records: any[][]): Promise<Record<string, any> | null> {

    const modal = await this.modalCtrl.create({
      component: RecordSelectionComponent,
      componentProps: { records },
      cssClass: 'record-selection-modal'

    });
    await modal.present();
    const { data, role } = await modal.onDidDismiss();
    return role === 'confirm' ? data : null;
  }

  // private async showRecordSelectionPopup(records: any[][]): Promise<any[] | null> {
  //   // Example using Ionic AlertController
  //   const alert = await this._alertController.create({
  //     header: 'Select Record',
  //     inputs: records.map((rec, index) => ({
  //       type: 'radio',
  //       label: rec.map(r => `${r.controlId}: ${r.apiResponseKeyValue}`).join(', '),
  //       value: index
  //     })),
  //     buttons: [
  //       { text: 'Cancel', role: 'cancel' },
  //       { text: 'OK', role: 'confirm' }
  //     ]
  //   });

  //   await alert.present();
  //   const { data, role } = await alert.onDidDismiss();

  //   if (role === 'confirm' && data?.values !== undefined) {
  //     return records[data.values]; // return selected record
  //   }
  //   return null;
  // }


  async updateChecklist(data: any, templateId: any): Promise<void> {
    try {
      const checklistUpdated: any = await this._localDbService.updateChecklistEnableControl(
        this.taskDetails.TaskId,
        data.isEnable,
        data.controlName,
        templateId,
        data.controlvalue
      );
    } catch (error) {

    }
  }

  async insertChecklistPrefill(data: any, templateId: any): Promise<void> {
    try {
      const checklistInsertion: any = await this._localDbService.saveChecklistThirdPatryCheckboxControlQues(
        data,
        templateId,
        this.taskDetails.TaskId,
        this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)),
        false
      );
    } catch (error) {

    }
  }

  checkDependentMediaExists(item: any, templateId: any): boolean {
    const dependentControlNames: string[] = item?.dependentControlVisibility?.map(
      (dep: any) => dep.controlName
    ) ?? [];

    if (dependentControlNames.length === 0) return false;
    console.log("this._tempDynamicStoreconfig", this._tempDynamicStoreconfig)
    const templateData = this._tempDynamicStoreconfig.serverData.find(
      (t: any) => t.templateId === templateId
    );
    console.log("templateData", templateData)

    if (!templateData) return false;
    const allMediaDetails: any[] = [];
    const fileMetaData: any[] = this._tempDynamicStoreconfig.fileMetaData ?? [];
    console.log("dependentControlNames", dependentControlNames)
    for (const controlName of dependentControlNames) {
      console.log("templateData.templateJson", templateData.templateJson)
      const control = this._tempDynamicStoreconfig.tempCustomJson.find(
        (c: any) => c.controlName === controlName
      );
      console.log("control", control);

      if (!control) continue;
      console.log("control", control)
      // Case 1: direct photos control
      if (control.controlType === 'photos' || control.controlType === 'videos' || control.controlType === 'files') {
        const matchedFiles = fileMetaData.filter(
          (f: any) => f.controlId === control.controlName
        );
        if (matchedFiles.length > 0) {
          allMediaDetails.push(...matchedFiles);
        }
      }


      // Case 2: title control — check children for photos
      else if (control.controlType === 'title') {
        if (Array.isArray(control.children) && control.children.length > 0) {
          for (const child of control.children) {
            console.log("child", child, fileMetaData)
            if (child.controlType === 'photos' || child.controlType === 'videos' || child.controlType === 'files') {
              const matchedFiles = fileMetaData.filter(
                (f: any) => f.controlId === child.controlName
              );
              console.log("matchedFiles", matchedFiles)
              if (matchedFiles.length > 0) {
                allMediaDetails.push(...matchedFiles);
              }
            }
          }
        }
      }
    }

    this.mediaDetails = allMediaDetails;
    return allMediaDetails.length > 0;
  }


  // Show popup (adapt to your UI framework — Alert, Modal, Toast, etc.)
  async showDeleteMediaFirstPopup(sectionName: any, mediaItems: any[], templateId: any): Promise<boolean> {
    return new Promise(async (resolve) => {
      const modal = await this.modalCtrl.create({
        component: DeleteMediaComponent,
        componentProps: {
          sectionName: sectionName,
          mediaItems: mediaItems,
          templateId: templateId
        },
        cssClass: 'delete-media-modal',
        breakpoints: [0, 1],
        initialBreakpoint: 1
      });

      await modal.present();
      const { data } = await modal.onWillDismiss();
      resolve(data?.confirmed === true);
    });
  }

  async onCheckChange(event: any, item: any, controlName: any, formData: any, templateName: any, templateId: any) {
    console.log("formData---", formData)
    const formArray: UntypedFormArray = this._customForm.get(controlName) as UntypedFormArray;
    const optionId = String(item.id);
    // ─── Media check on uncheck ──────────────────────────────────────────────
    if (!event.target.checked) {
      const hasMedia = this.checkDependentMediaExists(item, templateId);
      if (hasMedia) {
        event.target.checked = true;
        item.isChecked = true;

        const confirmed = await this.showDeleteMediaFirstPopup(
          item.option[this._appSetting.selectedLanguage],
          this.mediaDetails,
          templateId
        );

        if (confirmed) {
          item.isChecked = false;
          event.target.checked = false;
          const idx = formArray.controls.findIndex(ctrl => ctrl.value === optionId);
          if (idx > -1) formArray.removeAt(idx);
          this.clearMediaFromTempJson(item);

          const isControlValue: any = await this._localDbService.getChecklistFromLocalDbByControlName(
            this.taskDetails.TaskId, controlName, templateId
          );
          if (isControlValue.status && isControlValue.data.length > 0) {
            await this.updateChecklistCheckboxontrolValue(formData, templateName, templateId);
          } else {
            await this.insertChecklistCheckboxControlcontrolvalue(formData, templateName, templateId);
          }
          // Remove dependent controls for this option
          await this.removeCheckboxDependentControls(item, formData, templateId);
          await this.hideShowCcheckboxControls(formData, templateId);
          this.formChanged.emit();
          this.templateQuesUpdated.emit(this.customFormJson);
        }
        return;
      }
    }
    // ─── Normal check/uncheck flow ───────────────────────────────────────────
    item.isChecked = event.target.checked;
    if (event.target.checked) {
      formArray.push(new UntypedFormControl(optionId));
    } else {
      const idx = formArray.controls.findIndex(ctrl => ctrl.value === optionId);
      if (idx > -1) formArray.removeAt(idx);
    }

    const isControlValue: any = await this._localDbService.getChecklistFromLocalDbByControlName(
      this.taskDetails.TaskId, controlName, templateId
    );
    if (isControlValue.status && isControlValue.data.length > 0) {
      await this.updateChecklistCheckboxontrolValue(formData, templateName, templateId);
    } else {
      await this.insertChecklistCheckboxControlcontrolvalue(formData, templateName, templateId);
    }
    // ─── Inject or remove dependentControls ─────────────────────────────────
    if (event.target.checked) {
      await this.injectCheckboxDependentControls(item, formData, templateId);
    } else {
      await this.removeCheckboxDependentControls(item, formData, templateId);
    }
    await this.hideShowCcheckboxControls(formData, templateId);
    this.formChanged.emit();
    console.log("this.customFormJson", this.customFormJson)
    this.templateQuesUpdated.emit(this.customFormJson);
  }
  async injectCheckboxDependentControls(item: any, formData: any, templateId: any) {
    if (!item?.dependentControls?.length) return;

    // Find zone index directly — same pattern as filterVal uses [i]
    const zoneIdx = this.customFormJson.findIndex((z: any) => z.templateId === templateId);
    if (zoneIdx === -1) return;

    const templateQues = this.customFormJson[zoneIdx].templateQues;

    // Avoid duplicate
    const alreadyExists = templateQues.some(
      (q: any) => q.parentControlName === formData.controlName &&
        item.dependentControls.some((dc: any) => dc.controlName === q.controlName)
    );
    if (alreadyExists) return;

    const dependentClones = item.dependentControls.map((dc: any) => ({
      id: dc.id,
      label: dc.label,
      isRequired: dc.isRequired,
      controlName: dc.controlName,
      controlType: dc.controlType,
      layoutClass: dc.layoutClass,
      placeholder: dc.placeholder,
      controlvalue: dc.controlvalue,
      controlwidth: dc.controlwidth,
      inputPattern: dc.inputPattern,
      controlParent: dc.controlParent,
      dependentControlDetail: dc.dependentControlDetail,
      controlOptions: dc.controlOptions,
      controlvalueKey: dc.controlvalueKey,
      parentControlName: formData.controlName,
      parentOptionId: item.id
    }));

    const parentIdx = templateQues.findIndex((q: any) => q.controlName === formData.controlName);
    const insertAt = parentIdx > -1 ? parentIdx + 1 : templateQues.length;

    // Direct mutation — same as filterVal
    this.customFormJson[zoneIdx].templateQues.splice(insertAt, 0, ...dependentClones);

    dependentClones.forEach((dc: any) => {
      if (!this._customForm.get(dc.controlName)) {
        this._customForm.addControl(dc.controlName, this._formBuilder.control(''));
      }
    });

    await this.saveTemplateQuesChangesToIdb(templateId);
    // this.templateQuesUpdated.emit(this.customFormJson);
  }

  async removeCheckboxDependentControls(item: any, formData: any, templateId: any) {
    if (!item?.dependentControls?.length) return;

    const controlNamesToRemove = item.dependentControls.map((dc: any) => dc.controlName);

    const zoneIdx = this.customFormJson.findIndex((z: any) => z.templateId === templateId);
    if (zoneIdx === -1) return;

    //Direct mutation
    this.customFormJson[zoneIdx].templateQues = this.customFormJson[zoneIdx].templateQues.filter(
      (q: any) => !(
        q.parentControlName === formData.controlName &&
        q.parentOptionId === item.id &&
        controlNamesToRemove.includes(q.controlName)
      )
    );

    for (const name of controlNamesToRemove) {
      await this._localDbService.deleteChecklistFromLocalDbByControlName(
        this.taskDetails.TaskId,
        name,
        templateId
      );
      this._customForm.removeControl(name);
    }

    await this.saveTemplateQuesChangesToIdb(templateId);

    // this.templateQuesUpdated.emit(this.customFormJson);
  }

  async saveTemplateQuesChangesToIdb(templateId: any) {
    const zone = this.customFormJson.find((z: any) => z.templateId === templateId);
    if (!zone) return;
    console.log("zone QUESTION", zone)
    await this._localDbService.updateTemplateAfterQuesAdd(
      this.taskDetails.TaskId,
      templateId,
      zone.templateQues  // full updated blob
    );
  }

  clearMediaFromTempJson(item: any) {
    const dependentControlNames: string[] = item?.dependentControlVisibility?.map(
      (dep: any) => dep.controlName
    ) ?? [];

    if (dependentControlNames.length === 0) return;

    const flatJson = this._tempDynamicStoreconfig.tempCustomJson;

    for (const controlName of dependentControlNames) {
      const control = flatJson.find((c: any) => c.controlName === controlName);
      console.log("control", control)
      if (!control) continue;

      // Case 1: direct photos — clear value
      if (control.controlType === 'photos') {
        delete control.value;
      }

      // Case 2: title — clear children photos value
      else if (control.controlType === 'title') {

        // State A: nested children
        if (Array.isArray(control.children) && control.children.length > 0) {
          control.children.forEach((child: any) => {
            if (child.controlType === 'photos') {
              delete child.value;
            }
          });
        }

        // State B: flat children
        flatJson
          .filter((c: any) => c.parent === controlName && c.controlType === 'photos')
          .forEach((child: any) => child.value = []);
      }
    }
  }


  // async hideShowCcheckboxControls(formData: any, templateId: any) {
  //   const templateDetails = await this._localDbService.getDynamicCardTaskTemplateFromIdb(
  //     this.taskDetails.TaskId
  //   );

  //   const controlVisibilityMap = new Map<string, boolean>();
  //   console.log("formData", formData)
  //   formData.controlOptions.forEach((opt: any) => {
  //     // opt?.dependentControlVisibility?.forEach((dep: any) => {
  //     //   controlVisibilityMap.set(dep.controlName, opt.isChecked);
  //     // });
  //     opt?.dependentControlVisibility?.forEach((dep: any) => {
  //       // If multiple options map to the same controlName, true wins
  //       const current = controlVisibilityMap.get(dep.controlName);
  //       if (!current) {
  //         controlVisibilityMap.set(dep.controlName, opt.isChecked);
  //       }
  //     });
  //   });
  //   console.log("controlVisibilityMap", controlVisibilityMap);
  //   const updateVisibility = (items: any[]) => {
  //     items.forEach(item => {
  //       // if (controlVisibilityMap.has(item.controlName)) {
  //       //   item.isVisible = controlVisibilityMap.get(item.controlName);
  //       // }
  //       if (controlVisibilityMap.has(item.controlName) && !item.parentControlName) {
  //         item.isVisible = controlVisibilityMap.get(item.controlName);
  //       }
  //     });
  //     return items;
  //   };
  //   this._tempDynamicStoreconfig.tempCustomJson = updateVisibility(
  //     this._tempDynamicStoreconfig.tempCustomJson
  //   );
  //   templateDetails.forEach((template: any, idx: number) => {
  //     templateDetails[idx].templateJson = updateVisibility(template.templateJson);
  //   });
  //   this._tempDynamicStoreconfig.serverData =
  //     this._tempDynamicStoreconfig.serverData.map(element => ({
  //       ...element,
  //       templateJson: updateVisibility(element.templateJson)
  //     }));
  //   console.log("this._tempDynamicStoreconfig.serverData|||||||||||||||||||||||", this._tempDynamicStoreconfig.serverData)
  //   for (const template of templateDetails) {
  //     await this._localDbService.updateTemplateAfterControlAdd(
  //       this.taskDetails.TaskId,
  //       template.templateId,
  //       template.templateJson
  //     );
  //   }
  // }

  async hideShowCcheckboxControls(formData: any, templateId: any) {
    const templateDetails = await this._localDbService.getDynamicCardTaskTemplateFromIdb(
      this.taskDetails.TaskId
    );

    // Use controlvalue (IDB source of truth) instead of opt.isChecked
    const checkedIds = new Set(
      (formData.controlvalue ?? []).map((v: any) => String(v))
    );

    const controlVisibilityMap = new Map<string, boolean>();

    formData.controlOptions.forEach((opt: any) => {
      // Derive checked state from controlvalue, not opt.isChecked
      const isChecked = checkedIds.has(String(opt.id));

      opt?.dependentControlVisibility?.forEach((dep: any) => {
        const existing = controlVisibilityMap.get(dep.controlName);
        if (existing !== true) {
          controlVisibilityMap.set(dep.controlName, isChecked);
        }
      });
    });

    console.log("controlVisibilityMap", controlVisibilityMap);

    const updateVisibility = (items: any[]) => {
      items.forEach(item => {
        if (controlVisibilityMap.has(item.controlName) && !item.parentControlName) {
          item.isVisible = controlVisibilityMap.get(item.controlName);
        }
      });
      return items;
    };

    this._tempDynamicStoreconfig.tempCustomJson = updateVisibility(
      this._tempDynamicStoreconfig.tempCustomJson
    );
    templateDetails.forEach((template: any, idx: number) => {
      templateDetails[idx].templateJson = updateVisibility(template.templateJson);
    });
    this._tempDynamicStoreconfig.serverData =
      this._tempDynamicStoreconfig.serverData.map(element => ({
        ...element,
        templateJson: updateVisibility(element.templateJson)
      }));
    for (const template of templateDetails) {
      await this._localDbService.updateTemplateAfterControlAdd(
        this.taskDetails.TaskId,
        template.templateId,
        template.templateJson
      );
    }
  }

  addnewrow(formData, tableData, zone, i) {
    this.getTable(formData, tableData, zone, i)
  }


  ngOnChanges(changes: SimpleChanges): void {
  }


  getGpsDetails() {
    this._appServices._gpsService.checkCurrentPosition().then((resp) => {
      this.lat = resp.coords.latitude;
      this.long = resp.coords.longitude;
    }, err => {
      this.getGpsDetails();
    });
  }




  fileCapture(obj) {
    this.previewFile = false;
    this.downloadFile = false;
    this.fileobj = obj;
    var files = document.getElementById(obj.controlName)['files'];
    if (files.length == 0) {
      return;
    }

    var formData = new FormData();
    formData.append("userId", this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)));
    formData.append("fileType", obj.controlType);
    formData.append("taskId", this.taskDetails.TaskId);
    formData.append("status", '1');
    formData.append("note", this.taskDetails.TaskId + '---' + obj.controlType);
    formData.append("metadata", '');
    formData.append("fileLat", this.lat);
    formData.append("fileLng", this.long);
    formData.append("cameraOrientation", 'NA');
    formData.append('file', files[0]);
    this._appServices.upload(environment.endpoint.fileUpload, formData).subscribe(_res => {
      if (_res.status == 'progress' && _res.message == 100) {

      } else if (_res.StatusCode == 200) {

        this.zoneKeys.forEach((key: any) => {
          if (this.customFormJson[key].length > 0) {
            this.customFormJson[key][0].data.filter((item: any) => {
              this._customForm.controls[obj.controlName].patchValue(_res.Data);
              obj.controlvalue = _res.Data;
            });
          }
        });
        this._customFormSummarySubmit();
        this.getFileList();
      }
    }, err => {
    });
  }


  documentMapFile(fileDetails) {
    var files = this.fileList.filter(file => file.serverFileName == fileDetails.fileName);
    if (files.length > 0) {
      var file = document.getElementById(this.fileobj.controlName)['files'];
      var url = URL.createObjectURL(file[0]);
      //  window.location.href = files[0].filePath;
      window.location.href = url;
      //  window.open(files[0].filePath);
    }
  }



  async getFileList() {
    var getTaskFilesPostJson = {
      "taskId": this.taskDetails.TaskId,
      "fileType": "files",
    };
    var taskDetail = {
      TaskId: this.taskDetails.TaskId,
      status: 'inprogress'
    }
      ; (await this._appServices.postData(environment.endpoint.getFile, getTaskFilesPostJson)).subscribe(_res => {
        var paramRequest = {
          httpRequest: {
            method: 'post',
            url: environment.endpoint.getFile,
            payLoad: getTaskFilesPostJson,
            response: {
              responseCode: _res.StatusCode,
              responseMsg: _res.Message,
              result: _res
            },
            // executionTime: ""
          },
          taskDetails: taskDetail
        }
        this._appServices.logsActivity(
          _res.StatusCode == 403
            ? this._appenum.EntityOfLogLevel.Warning
            : _res.StatusCode == 200
              ? this._appenum.EntityOfLogLevel.Info
              : this._appenum.EntityOfLogLevel.Error,
          'getFile Api Call',
          this.componentName,
          paramRequest.httpRequest,
          paramRequest.taskDetails,
          environment.endpoint.getFile
        );

        if (_res.StatusCode == 200) {
          this.fileList = _res.Data;
          this.previewFile = true;
          this.downloadFile = true;
        }
      }, err => {
        var paramRequest = {
          httpRequest: {
            method: 'post',
            url: environment.endpoint.getFile,
            payLoad: getTaskFilesPostJson,
            response: {
              responseCode: err.status,
              responseMsg: err.message,
              result: err
            },
            // executionTime: ""
          },
          taskDetails: taskDetail
        }
        this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Error, 'getFile Api Call', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.getFile);
      });
  }
  isHeading(formData) {
    return formData.controlType != 'label' && formData.controlType != 'catheading' && formData.controlType != 'catsubheading';
  }

  // dynamicIndent(formData) {
  //   if (formData.controlParent) {
  //     var parentStyle = document.getElementById(formData.controlParent).style.paddingLeft.split('px')[0];
  //     return { "padding-left": parseInt(parentStyle ? parentStyle : "0") + 15 + "px" };
  //   } else {
  //     return {};
  //   }
  // }
  async openPreInspectionReport(myval) {
    var obj = {
      component: PreInspectionReportComponent,
      cssClass: 'my-custom-class1',
      componentProps: { instructionVal: myval.controlvalue }
    }
    let modal = await this.modalCtrl.create(obj);
    modal.present();
  }

  getTable(tableData, values: any, zone, i) {
    const v = JSON.parse(JSON.stringify(values[0]));;
    var d: any = Object.values(v);
    var prefix = new Date().valueOf();
    for (let a of d[0]) {
      a.controlvalue = ''
      a.id = a.id + prefix;
    }
    this.lastKey = tableData.tableData.value.length + 1
    const addnew: any = [{
      lastKey: d[0]
    }]
    addnew.forEach(obj =>
      renameKey(obj, 'lastKey', this.lastKey)
    );
    const updatedJson = addnew;
    for (let j of this.customFormJson[i].templateQues) {
      if (j.id == tableData.id) {
        j.tableData.value.push(updatedJson[0])
      }
    }

  }
  setTableCtlVal(e, obj) {
    obj[e.name] = e.value;
  }

  async removeRow(i, tableData) {
    const alert = await this._alertController.create({
      cssClass: 'Confirmation_popup regularFonts',
      header: this.confirmText,
      message: '<p class="m-b-10">' + this.deleteRowMsg + '</p>',
      buttons: [
        {
          text: this.cancelText,
          role: 'cancel',
          cssClass: ['confirmation_cancel_button', 'confirmation_popup_button'],
          handler: (blah) => {
          }
        }, {
          text: this.yesText,
          cssClass: ['confirmation_ok_button', 'confirmation_popup_button'],
          handler: () => {
            this.removeconfirmRow(i, tableData)
          }
        }
      ]
    });
    await alert.present();
  }

  removeconfirmRow(i, tableData) {
    if (i != tableData.length - 1) {
      tableData.splice(i, 1);
      let count = 0
      for (let l of tableData) {
        count++
        var key = Object.keys(l);
        var key2 = (Number(key[0]));
        if (count != key2) {
          l[count] = l[key2];
          delete l[key2];
        }
      }
    } else {
      tableData.splice(i, 1);
      let count = 0
      for (let l of tableData) {
        count++
        var key = Object.keys(l);
        var key2 = (Number(key[0]));
        l[count] = l[key2];

      }
    }
  }
  async getTableData(val, index, tableform, templateName, templateId) {
    var obj = {
      component: CustomTablevalComponent,
      cssClass: 'my-custom-class1',
      componentProps: { value: val[index + 1], }
    }
    let modal = await this.modalCtrl.create(obj);
    modal.present();
    this.tableRowvalue = await modal.onWillDismiss();
    if (this.tableRowvalue.data?.dismissed == 'save') {
      await this.insertorupdatetablevalue(tableform, templateName, templateId);
    }
    if (this.tableRowvalue.data?.dismissed == 'save') {
      this.customFormJson[0].templateQues.forEach(item => {
        if (item.controlType == 'table' && (tableform.controlName == item.controlName)) {
          item.tableData.value = tableform.tableData.value
          item.controlvalue = 'abc';
        }
      })
      if (this.PageName != "dynamicCard") {
        this._customFormValues.emit(this.customFormJson);
      }
    }
  }


  async insertorupdatetablevalue(tableData: any, templateName: string, templateId: any): Promise<void> {
    try {
      const isControlValue: any = await this._localDbService.getChecklistFromLocalDbByControlName(
        this.taskDetails.TaskId,
        tableData.controlName,
        templateId
      );
      if (isControlValue.status && isControlValue.data.length > 0) {
        await this.updateChecklistTableControlValue(tableData, templateName, templateId);
      } else {
        await this.insertChecklistControlcontrolvalue(tableData, templateName, templateId);
      }
    } catch (error) {

    }
  }

  async updateChecklistTableControlValue(data: any, templateName: string, templateId: any): Promise<void> {
    try {
      await this._localDbService.updateChecklistTableControl(
        this.taskDetails.TaskId,
        data.controlName,
        JSON.stringify(data.tableData.value),
        templateId
      );
      this._tempDynamicStoreconfig.checklistChanges = true;
    } catch (error) {

    }
  }

  async insertChecklistControlcontrolvalue(data: any, templateName: string, templateId: any): Promise<void> {
    try {
      await this._localDbService.saveChecklistQues(
        data,
        templateId,
        templateName,
        this.taskDetails.TaskId,
        this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)),
        false,
        ''
      );
      this._tempDynamicStoreconfig.checklistChanges = true;
    } catch (error) {

    }
  }

  toggleTooltip(description) {
    this.description = description
    this.isTooltipVisible = !this.isTooltipVisible;
  }

  async insertcontrolvalue(data: any, templateName: string, templateId: any): Promise<void> {
    try {
      const checklistInsertion: any = await this._localDbService.saveChecklistQues(
        data,
        templateId,
        templateName,
        this.taskDetails.TaskId,
        this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)),
        false,
        ''
      );
      this._tempDynamicStoreconfig.checklistChanges = true
    } catch (error) {

    }
  }

  async updateChecklistTableValue(data: any, templateName: string, templateId: any): Promise<void> {
    try {
      const checklistUpdated: any = await this._localDbService.updateChecklistTable(
        this.taskDetails.TaskId,
        data.controlType,
        data.controlName,
        data.controlvalue,
        templateName,
        templateId
      );
      this._tempDynamicStoreconfig.checklistChanges = true

    } catch (error) {

    }
  }
  async updateChecklistCheckboxontrolValue(data, templateName, templateId) {
    try {
      var checklistUpdated: any = await this._localDbService.updateChecklistTableControl(this.taskDetails.TaskId, data.controlName, JSON.stringify(data.controlvalue), templateId)
      this._tempDynamicStoreconfig.checklistChanges = true;
    } catch (error) {

    }
  }

  async insertChecklistCheckboxControlcontrolvalue(data, templateName, templateId) {
    try {
      var checklistinsertion: any = await this._localDbService.saveChecklistCheckboxControlQues(data, templateId, templateName, this.taskDetails.TaskId, this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)), false)
      this._tempDynamicStoreconfig.checklistChanges = true;
    } catch (error) {

    }
  }

  async generateReportSummary(formData: any, templateId: any) {

    const matchedTemplate = this._tempDynamicStoreconfig.serverData.find(t => t.templateId === templateId);
    const templateJson = matchedTemplate ? matchedTemplate.templateJson : null;
    const templateQues = matchedTemplate ? matchedTemplate.templateQues : null;

    // Run validation first (mandatory/recommended photos, required fields)
    const validation = await this.validateBeforePayload(templateJson, templateQues, this._alertController);
    if (validation.stopProcessing) {
      return; // Stop payload & API call
    }

    // Check if Report Summary (base_ques24) already exists before API call
    const existingValue = this._customForm.controls["base_ques24"].value;
    if (existingValue && existingValue.trim() !== '') {
      var message = this._translateService.instant('third_party_text.Do_you_want_replace_existing_Report_Summary');
      var headertitle = this._translateService.instant('third_party_text.report_summary_already_exist');

      const alert = await this._alertController.create({
        header: headertitle,
        message: message,
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              console.log('User chose not to replace AI Summary');
            }
          },
          {
            text: 'Yes',
            handler: async () => {
              await alert.dismiss();
              // Proceed with API call only when user confirms
              await this.callReportSummaryAPI(formData, templateJson, templateQues);
            }
          }
        ]
      });
      await alert.present();
      return;
    }

    // If no Report summary exists, call API directly
    await this.callReportSummaryAPI(formData, templateJson, templateQues);
  }

  async callReportSummaryAPI(formData: any, templateJson: any[], templateQues: any[]) {
    const result = templateJson
      .filter(item => item.controlType === 'photos')
      .map(item => {
        const hasPhotos = Array.isArray(item.value) && item.value.length > 0;

        if (hasPhotos) {
          // Photos taken
          return {
            type_Of_Photo: item.parent
              ? `${item.parent}/${item.controlName}`
              : item.controlName,
            photo_taken: true,
            agent_observation_text: item.value[0]?.observationText || "",
            AI_observation_text: item.value[0]?.AIObservation || "",
            image_tag: item.value[0]?.MetaData
          };
        } else {
          // No photos taken
          return {
            type_Of_Photo: item.parent
              ? `${item.parent}/${item.controlName}`
              : item.controlName,
            photo_taken: false
          };
        }
      });
    const resultOftemplateQues = templateQues
      .filter(item => ['text', 'textarea', 'select', 'checkbox'].includes(item.controlType))
      .map(item => {
        let answerValue = item.controlvalue || '';

        // For select — get the label of the selected option
        if (item.controlType === 'select' && Array.isArray(item.controlOptions)) {
          const selectedOption = item.controlOptions.find(opt => opt.id === item.controlvalue);
          answerValue = selectedOption ? selectedOption.option?.en || '' : '';
        }

        // For checkbox — get selected options as comma-separated text
        if (item.controlType === 'checkbox' && Array.isArray(item.controlOptions)) {
          const selectedChoices = item.controlOptions
            .filter(opt => Array.isArray(item.controlvalue) && item.controlvalue.includes(opt.id))
            .map(opt => opt.option?.en || '');
          answerValue = selectedChoices.join(', ');
        }

        // Build response based on control type
        if (['select', 'checkbox'].includes(item.controlType)) {
          const possibleAnswers = (item.controlOptions || [])
            .map(opt => opt.option?.en || '')
            .filter(optText => !answerValue.split(', ').includes(optText));

          return {
            Question: item.label?.en || '',
            Answer: answerValue || '',
            possible_answers_choice: possibleAnswers
          };
        } else {
          return {
            Question: item.label?.en || '',
            Answer: answerValue || ''
          };
        }
      });
    // Prepare payload and call API
    formData.status = 'loading';
    this._appServices.presentLoading('Please wait report summary generating')
    const postJson = {
      orgId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId)),
      aiTypeId: 'AI_4',
      data: {
        "businesName": "Home Insurance",
        "documentName": "AEGIS Policy",
        "taskName": "New Inspection",
        "taskId": this.taskDetails.TaskId,
        "checklistQuesData": resultOftemplateQues,
        "photosData": result
      }
    };
    try {
      const res: any = await this._appServices.postDataWithPromise(environment.endpoint.generateReportAiSummary, postJson);
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: environment.endpoint.generateReportAiSummary,
          payLoad: postJson,
          response: {
            responseCode: res.StatusCode,
            responseMsg: res.Message,
            result: res
          },
          // executionTime: ""
        },
        taskDetails: null
      }
      this._appServices.logsActivity(
        res.StatusCode == 200
          ? this._appenum.EntityOfLogLevel.Info
          : this._appenum.EntityOfLogLevel.Critical,
        `${res.StatusCode != 200 ? 'FRONTEND_ALERT ' : ''} Call generateReportAiSummary Api To Generate Report Summary`,
        this.componentName,
        paramRequest.httpRequest,
        paramRequest.taskDetails,   // taskDetails - not passed in original, keeping as-is
        environment.endpoint.generateReportAiSummary
      );
      formData.status = 'default';
      this._appServices.loaderDismiss()
      if (res.StatusCode == 200) {
        const llmData = res.Data[0].llm_data != null ? res.Data[0].llm_data : '';
        this.updateLLMData(templateQues, llmData, this._alertController);
      } else {
        var msg = this._translateService.instant('third_party_text.Report_Summary_Generation_Failed_Try_Later');
        this._appServices.presentToast(msg);
      }
    } catch (err) {
      formData.status = 'default';
      this._appServices.loaderDismiss()
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: environment.endpoint.generateReportAiSummary,
          payLoad: postJson,
          response: {
            responseCode: err.status,
            responseMsg: err.message,
            result: err
          },
          // executionTime: ""
        },
        taskDetails: null
      }
      this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Critical, 'FRONTEND_ALERT Call generateReportAiSummary Api To Generate Report Summary', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.generateReportAiSummary);

    }
  }

  async updateLLMData(templateQues: any[], llmData: string, alertCtrl: AlertController) {
    if (!llmData) return;

    const cleanedData = llmData.replace(/\*\*/g, '').trim();
    const ques = templateQues.find(q => q.controlvalueKey === 'llm_data');
    if (!ques) return;
    // Set the cleaned LLM data into the form and JSON
    this._customForm.controls["base_ques24"].patchValue(cleanedData);
    ques.controlvalue = cleanedData;
  }

  async validateBeforePayload(
    templateJson: any[],
    templateQues: any[],
    alertCtrl: AlertController
  ): Promise<ValidationResult> {

    const mandatoryPhotosMissing = templateJson.filter(
      item => item.controlType === 'photos' && item.mandatory === 1 && (!Array.isArray(item.value) || item.value.length === 0)
    );

    const recommendedPhotosMissing = templateJson.filter(
      item => item.controlType === 'photos' && item.mandatory === 2 && (!Array.isArray(item.value) || item.value.length === 0)
    );

    const requiredQuestionsMissing = templateQues.filter(ques => {
      if (ques.skipRequiredCheck) {
        return false;
      }
      let isControlValueEmpty = false;
      if (Array.isArray(ques.controlvalue)) {
        isControlValueEmpty = ques.controlvalue.length === 0;
      } else {
        isControlValueEmpty = ques.controlvalue?.trim?.() === '';
      }

      const isVisibleForApp = !ques.visibleOn ||
        (Array.isArray(ques.visibleOn) && ques.visibleOn.includes(this._appServices.appType));
      return ques.isRequired && isControlValueEmpty && isVisibleForApp;
    });

    const hasMandatoryPhotosMissing = mandatoryPhotosMissing.length > 0;
    const hasRecommendedPhotosMissing = recommendedPhotosMissing.length > 0;
    const hasRequiredQuestionsMissing = requiredQuestionsMissing.length > 0;


    switch (true) {
      // Case 1: Mandatory questions + mandatory photos missing
      case hasMandatoryPhotosMissing && hasRequiredQuestionsMissing: {

        const alert = await alertCtrl.create({
          header: this._translateService.instant('third_party_text.missing_data'),
          message: this._translateService.instant('third_party_text.complete_required_fields_capture_mandatory_media_to_generate_report_summary'),
          buttons: ['OK']
        });
        await alert.present();
        return { stopProcessing: true };
      }

      // Case 2: Mandatory questions missing but no mandatory media missing
      case !hasMandatoryPhotosMissing && hasRequiredQuestionsMissing: {
        const alert = await alertCtrl.create({
          header: this._translateService.instant('third_party_text.missing_data'),
          message: this._translateService.instant('third_party_text.fill_required_form_fields_to_generate_AI_report_summary'),
          buttons: ['OK']
        });
        await alert.present();
        return { stopProcessing: true };
      }

      // Case 3: Only mandatory photos missing (questions filled)
      case hasMandatoryPhotosMissing && !hasRequiredQuestionsMissing: {
        const alert = await alertCtrl.create({
          header: this._translateService.instant('third_party_text.missing_data'),
          message:
            this._translateService.instant('third_party_text.capture_mandatory_media_to_generate_report_summary'),
          buttons: ['OK']
        });
        await alert.present();
        return { stopProcessing: true };
      }

      // Case 4: Only recommended photos missing
      case hasRecommendedPhotosMissing && !hasMandatoryPhotosMissing && !hasRequiredQuestionsMissing: {
        return new Promise<ValidationResult>(async (resolve) => {
          const alert = await alertCtrl.create({
            header: this._translateService.instant('third_party_text.recomended_photos_text'),
            message:
              this._translateService.instant('third_party_text.Are_you_sure_want_to_generate_Report_Summary_without_recommended_details'),
            buttons: [
              {
                text: 'No',
                handler: () => resolve({ stopProcessing: true })
              },
              {
                text: 'Yes, Generate',
                handler: () => resolve({ stopProcessing: false, canSkipRecommended: true })
              }
            ]
          });
          await alert.present();
        });
      }

      // Default: All validations passed
      default:
        return { stopProcessing: false };
    }
  }

  autoResize(event: any): void {
    try {
      const textarea = event.target as HTMLTextAreaElement;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    } catch (error) {
      console.error('Auto resize error:', error);
    }
  }

  trackByControlName(index: number, ques: any): string {
    return ques.controlName; // stable unique key for inner loop
  }

  trackByTemplateId(index: number, zone: any): string {
    return zone.templateId; // stable unique key for outer loop
  }

}



function renameKey(obj, oldKey, newKey) {
  obj[newKey] = obj[oldKey];
  delete obj[oldKey];
}